import { useState, useEffect, useMemo } from 'react';
import { useIModelClient, getAuthorizationForIModelClient } from '../useIModelClient/useIModelClient';
import { useUserContext } from '../../context/userContext/userContext';

export interface iModelUser {
  id: string;
  givenName: string;
  surname: string;
  email: string;
}

type iModelAPIOptionsType = {
  iModelId: string;
  authorization: () => Promise<{
    scheme: string;
    token: string;
  }>;
};

export const useFetchiModelUsers = (iModelId: string) => {
  const [users, setUsers] = useState<iModelUser[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { iModelsClient } = useIModelClient();
  const { user } = useUserContext();
  const iModelAPIOptions = useMemo<iModelAPIOptionsType>(() => ({
    iModelId,
    authorization: async () => getAuthorizationForIModelClient(user.access_token, user.token_type),
  }), [iModelId, user]);

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      try {
        if (iModelsClient && iModelAPIOptions && iModelId) {
          let fetchedUsers: iModelUser[] = [];
          const userIterator = iModelsClient.users.getRepresentationList(iModelAPIOptions).byPage();
          for await (const userPage of userIterator) {
            fetchedUsers = fetchedUsers.concat(userPage);
          }
          setUsers(fetchedUsers);
        }
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (iModelId) {
      fetchUsers();
    }
  }, [iModelsClient, iModelAPIOptions, iModelId]);

  return { users, isLoading };
};
